// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__8ivrh","formError":"LoginForm_formError__uGRAL","submitBtn":"LoginForm_submitBtn__w66Bo","active":"LoginForm_active__5jDk0"};